import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters({
      order: "order/order",
      orderImages: "order/images",
      isCreatingOrder: "order/isCreatingOrder",
    }),

    formSteps() {
      return ["step-one", "step-two", "step-three", "step-four"].filter(
        (step) => step !== this.$route.name
      );
    },
  },

  watch: {
    "order.name"(val) {
      this.setIsCreatingOrder(!!val);
    },
    "order.instruction"(val) {
      this.setIsCreatingOrder(!!val);
    },
    orderImages(val) {
      this.setIsCreatingOrder(!!val?.length);
    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.formSteps.includes(to.name) || !this.isCreatingOrder) {
      this.setIsCreatingOrder(false);
      next();
      return;
    }

    this.confirmLeavingPage().then((isConfirmed) => {
      if (isConfirmed) {
        this.setIsCreatingOrder(false);
        next();
      }
    });
  },

  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);

    if (this.order.name || this.order.instruction || this.orderImages?.length) {
      this.setIsCreatingOrder(true);
    }
  },

  methods: {
    ...mapActions({
      setIsCreatingOrder: "order/setIsCreatingOrder",
    }),

    preventNav(event) {
      event.preventDefault();
      event.returnValue = "";
    },

    async confirmLeavingPage() {
      const confirm = await this.$swal({
        title: "⚠️ Order In-progress",
        text: "You are currently in the middle of an order, if you leave it will not be submitted.",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Leave",
        cancelButtonText: "Cancel",
      });

      return confirm.value;
    },
  },
};
